import React from 'react';
import { XCircle } from 'lucide-react';
import { ScrollFadeIn } from './ScrollFadeIn';
const approaches = [{
  title: 'Standard HIIT Workouts',
  description: "Are spiking your cortisol even higher, telling your body to store fat for a 'coming famine.'"
}, {
  title: 'Low-Carb Diets at Night',
  description: "Trigger a 'Metabolic Panic' that forces your liver to wake you up at 3 AM for fuel."
}, {
  title: 'Melatonin Supplements',
  description: "Only mask the sleep signal but can't override the adrenaline surging through your veins."
}, {
  title: '"Powering Through"',
  description: "Only deepens the hormonal exhaustion, making your 'Stress Belly' firmer and more permanent."
}];
export function FailedApproaches() {
  return <section className="py-10 bg-slate-800/50" data-id="element-207">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-208">
        <ScrollFadeIn data-id="element-209">
          <div className="text-center mb-16" data-id="element-210">
            <h2 className="text-3xl md:text-4xl font-serif text-slate-50 mb-4" data-id="element-211">
              Why What You Tried Didn't Work
            </h2>
            <p className="text-lg text-slate-400 max-w-2xl mx-auto" data-id="element-212">
              Traditional fitness advice wasn't built for a nervous system stuck
              in overdrive.
            </p>
          </div>
        </ScrollFadeIn>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-213">
          {approaches.map((approach, index) => <ScrollFadeIn key={index} delay={index * 0.1} data-id="element-214">
              <div className="bg-slate-800 border border-slate-700 p-6 rounded-xl flex items-start space-x-4" data-id="element-215">
                <XCircle className="w-6 h-6 text-rose-400 shrink-0 mt-1" data-id="element-216" />
                <div data-id="element-217">
                  <h3 className="text-xl font-medium text-slate-50 mb-2" data-id="element-218">
                    {approach.title}
                  </h3>
                  <p className="text-slate-400 leading-relaxed" data-id="element-219">
                    {approach.description}
                  </p>
                </div>
              </div>
            </ScrollFadeIn>)}
        </div>
      </div>
    </section>;
}